import styled from 'styled-components';
import TickSolid from '@simplywallst/ui-core/icons/TickSolid';

export const StyledTickSolid = styled(TickSolid)`
  && * {
    fill: ${({ theme }) => theme.color.good};
  }
`;
